import { render, staticRenderFns } from "./room-publish.vue?vue&type=template&id=40ca9972"
import script from "./room-publish.vue?vue&type=script&lang=js"
export * from "./room-publish.vue?vue&type=script&lang=js"
import style0 from "./room-publish.vue?vue&type=style&index=0&id=40ca9972&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports